import request from '@/request/request'
let baseURL =  global.$config.api.system_url + '/emergency-server/'
// 新增应急预案附件任务
export function save(data) {
    return request({
        baseURL,
        url: '/emergencyPlanAttach/save',
        method: 'post',
        data
    })
}
// 修改应急预案附件任务
export function update(data) {
    return request({
        baseURL,
        url: '/emergencyPlanAttach/update',
        method: 'post',
        data
    })
}
//查询应急预案附件任务列表
export function list(params) {
    return request({
        baseURL,
        url: '/emergencyPlanAttach/list',
        method: 'get',
        params
    })
}
//查询应急预案附件任务
export function detail(id) {
    return request({
        baseURL,
        url: '/emergencyPlanAttach/detail?id=' + id,
        method: 'get',
    })
}
//删除应急预案附件任务
export function remove(data) {
    return request({
        baseURL,
        url: '/emergencyPlanAttach/remove',
        method: 'post',
        data: { ...data, isFormData:true }
    })
}